










































import Vue from "vue";
import DataPrivacyComp from "@/components/legal/DataPrivacyComp.vue";
import data from "./data.json";

export default Vue.extend({
	name: "LegalNoticeComp",
	components: { DataPrivacyComp },
	data: () => ({
		data: data,
	}),
});
